var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('Loading',{attrs:{"variant":"main"}}):(_vm.isViewGA4)?_c('ResultsCheckGA4',{attrs:{"id":_vm.id,"keyword":_vm.keyword,"project":_vm.project,"status":_vm.status}}):_c('ResultsCheckUA',{attrs:{"id":_vm.id,"keyword":_vm.keyword,"project":_vm.project,"status":_vm.status,"isGaTypeError":_vm.isGaTypeError}})
}
var staticRenderFns = []

export { render, staticRenderFns }